// Copied from Ascend
import { Box, TabListProps, useMultiStyleConfig } from "@chakra-ui/react";
import { SystemStyleObject } from "@chakra-ui/system";

export interface RouteTabListProps extends TabListProps {}

export const RouteTabList = (props: RouteTabListProps) => {
  const styles = useMultiStyleConfig("Tabs", props);
  const tablistStyles: SystemStyleObject = {
    display: "flex",
    gap: 1,
    ...styles.tablist,
    borderBottomWidth: 1,
    borderColor: "gray.400",
  };
  return <Box {...props} __css={tablistStyles} />;
};
